// Core
import { Component } from '@angular/core';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCode, faGlobe, faServer, faEnvelope, faMobile } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-index-services-section',
    imports: [FontAwesomeModule],
    templateUrl: './index-services-section.html',
    styleUrl: './index-services-section.scss',
})
export class IndexServicesSection {

    // Font Awesome Icons
    faCode = faCode;
    faMobile = faMobile;
    faGlobe = faGlobe;
    faServer = faServer;
    faEnvelope = faEnvelope;
}
